import { Box } from '@chakra-ui/react'
import _ from 'lodash'
import ExpandableText from 'src/components/widgets/ExpandableText/ExpandableText'
import { ItList } from 'types/graphql'

const Description: React.FC<{
  itList: ItList
  isPreview: boolean
  locked: boolean
}> = ({ itList, isPreview, locked }) => (
  <Box
    px={{ base: 4, lg: isPreview ? 4 : 24 }}
    my={6}
    id="it-list-item-description"
  >
    {itList.description ? (
      <ExpandableText
        data-testid="itListDetails-description"
        color="onyx"
        text={itList.description}
      />
    ) : (
      <Box
        className="body-regular"
        color="graphite"
        data-testid="itListDetails-NoDescription"
      >
        No description yet...
      </Box>
    )}
    {!locked && itList.relationship !== 'owner' && (
      <Box mt={6}>
        <Box className="body-extra-small" color="graphite">
          ItLists may generate small affiliate commissions for some creators.
        </Box>
      </Box>
    )}
  </Box>
)

export default Description
